/*
 * use-network-status
 */
import { useEffect, useState } from "react"

export type NetworkStatus = {
	isOnline: boolean | null
	offlineAt: Date | null
	onlineAt: Date | null
}

export function useNetworkStatus(): NetworkStatus {
	/* State */
	const [isOnline, setIsOnline] = useState<boolean | null>(
		typeof navigator === "undefined" ? null : navigator.onLine,
	)
	const [offlineAt, setOfflineAt] = useState<Date | null>(
		typeof navigator === "undefined" || navigator.onLine ? null : new Date(),
	)
	const [onlineAt, setOnlineAt] = useState<Date | null>(
		typeof navigator === "undefined" || navigator.onLine ? new Date() : null,
	)

	/* Handler */
	function handleChange() {
		const online = navigator.onLine
		setIsOnline(online)
		if (online) {
			setOnlineAt(new Date())
		} else {
			setOfflineAt(new Date())
		}
	}

	/* Effect */
	useEffect(() => {
		if (typeof window === "undefined") {
			return
		}

		window.addEventListener("online", handleChange)
		window.addEventListener("offline", handleChange)

		return () => {
			window.removeEventListener("online", handleChange)
			window.removeEventListener("offline", handleChange)
		}
	}, [])

	return { isOnline, onlineAt, offlineAt }
}
